<template>
	<div class="container-fluid">
		<div class="m-2">
			<div class="alert alert-primary h4 text-center">
                <linkto :link="'/'"/>
                Feladat keresés
    		</div>
		</div>
		<div class="row d-flex justify-content-center mt-2">
			<div class="col-12 col-md-4">
				<label class="h5">
					Felelős
				</label>
				<select v-model="search.userid" class="form-control">
				  	<option
				  		v-for="(v,k) in users"
				  		:key="k"
				  		:value="v.azon"
				  	>
				  		{{ v.nev }}
				  	</option>
				</select>
			</div>
			<div class="col-12 col-md-4">
				<label class="h5">
					Státusz
				</label>
				<select class="form-control" v-model="search.aktiv">
					<option value="2">Mind</option>
					<option value="0">Lezárt</option>
					<option value="1">Nyitott</option>
				</select>
			</div>
			<div class="col-12 col-md-4">
				<label class="h5">
					Leírás
				</label>
				<input type="text" class="form-control" v-model="search.feladat">
			</div>
			<!--<div class="col-12 col-md-4">
				<label class="h5">
					Ügyfél
				</label>
				<input type="text" class="form-control" v-model="search.ugyfel">
			</div>-->
			<div class="col-12 col-md-4 mt-2">
				<div class="row d-flex justify-content-center no-gutters">
					<label class="col-12 h5">
						Rögzítés dátuma
					</label>
					<div class="col-6">
		        		<div class="m-1">
		        			<span class="float-right">
		        				<button
		        					class="btn btn-sm btn-outline-danger"
		        					@click.prevent="del(`r_datum_tol`)"
		        				>
		        					Üres
		        				</button>
		        			</span>
		  					<date-picker class="text-center" v-model="search.r_datum_tol" :config="date_options" placeholder="-tól"/>
		        		</div>
		  			</div>
		  			<div class="col-6">
		  				<div class="m-1">
		  					<span class="float-right">
		        				<button
		        					class="btn btn-sm btn-outline-danger"
		        					@click.prevent="del(`r_datum_ig`)"
		        				>
		        					Üres
		        				</button>
		        			</span>
		        			<date-picker class="text-center" v-model="search.r_datum_ig" :config="date_options" placeholder="-ig"/>
		  				</div>
		        	</div>
				</div>
			</div>
			<div class="col-12 col-md-4 mt-2">
				<div class="row d-flex justify-content-center no-gutters">
					<label class="col-12 h5">
						Határidő
					</label>
					<div class="col-6">
		        		<div class="m-1">
		        			<span class="float-right">
		        				<button
		        					class="btn btn-sm btn-outline-danger"
		        					@click.prevent="del(`h_datum_tol`)"
		        				>
		        					Üres
		        				</button>
		        			</span>
		  					<date-picker class="text-center" v-model="search.h_datum_tol" :config="date_options" placeholder="-tól"/>
		        		</div>
		  			</div>
		  			<div class="col-6">
		  				<div class="m-1">
		  					<span class="float-right">
		        				<button
		        					class="btn btn-sm btn-outline-danger"
		        					@click.prevent="del(`h_datum_ig`)"
		        				>
		        					Üres
		        				</button>
		        			</span>
		        			<date-picker class="text-center" v-model="search.h_datum_ig" :config="date_options" placeholder="-ig"/>
		  				</div>
		        	</div>
				</div>
			</div>
			<div class="col-12 col-md-4 mt-2">
				<div class="row d-flex justify-content-center no-gutters">
					<label class="col-12 h5">
						Lezárás dátuma
					</label>
					<div class="col-6">
		        		<div class="m-1">
		        			<span class="float-right">
		        				<button
		        					class="btn btn-sm btn-outline-danger"
		        					@click.prevent="del(`l_datum_tol`)"
		        				>
		        					Üres
		        				</button>
		        			</span>
		  					<date-picker class="text-center" v-model="search.l_datum_tol" :config="date_options" placeholder="-tól"/>
		        		</div>
		  			</div>
		  			<div class="col-6">
		  				<div class="m-1">
		  					<span class="float-right">
		        				<button
		        					class="btn btn-sm btn-outline-danger"
		        					@click.prevent="del(`l_datum_ig`)"
		        				>
		        					Üres
		        				</button>
		        			</span>
		        			<date-picker class="text-center" v-model="search.l_datum_ig" :config="date_options" placeholder="-ig"/>
		  				</div>
		        	</div>
				</div>
			</div>
		</div>
		<div class="row d-flex justify-content-center mt-2">
			<div class="col-12 text-center">
				<button class="btn btn-lg btn-primary m-1" @click.prevent="load">
					Keresés
				</button>
				<button class="btn btn-lg btn-success m-1" disabled v-show="list.length > 0">
					{{ list.length }} feladat
				</button>
			</div>
		</div>
		<div class="row d-flex justify-content-center">
			<task-list
				:list="list"
				@checkedChange="checkedHandler"
			>
			</task-list>
		</div>
		<div
			class="row d-flex justify-content-center pb-3"
			v-if="checked.length != 0"
		>
			<div class="col-12 col-md-6 text-center">
				<div class="m-1 alert alert-primary">
					<span class="h5 font-weight-bold">
						Csoportos feladat módosítás
					</span>
				</div>
			</div>
			<div class="col-12">
				<div class="row d-flex justify-content-center">
					<div class="col-12 col-md-6">
						<div class="row d-flex justify-content-center align-items-center">
							<div class="col-9">
								<label class="h5">
									Határidő módosítás
								</label>
								<date-picker
									class="text-center"
									v-model="cshatarido"
									:config="date_options"
									placeholder=""
								/>
							</div>
							<div class="col-3">
								<button
									class="btn btn-primary"
									@click.prevent="change('hatarido')"
								>
									Módosít
								</button>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-6">
						<div class="row d-flex justify-content-center align-items-center">
							<div class="col-9">
								<label class="col-12 h5">
									Felelős módosítás
								</label>
								<select v-model="csfelelos" class="form-control">
								  	<option
								  		v-for="(v,k) in users"
								  		v-if="v.azon != 99"
								  		:key="k"
								  		:value="v.azon"
								  	>
								  		{{ v.nev }}
								  	</option>
								</select>
							</div>
							<div class="col-3">
								<button
									class="btn btn-primary"
									@click.prevent="change('userid')"
								>
									Módosít
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
import {mapGetters} from 'vuex'
import taskList from '@/components/tasks/taskList'
export default {
	components: {
		taskList
	},

	data() {
		return {
			search: {
				aktiv: 1,
				h_datum_ig: this.$moment().format('YYYY-MM-DD')
			},
			users: [],
			list: [],
			checked: [],
			cshatarido: this.$moment().format('YYYY-MM-DD'),
			csfelelos: 0
		}
	},

	mounted() {
		this.init()
	},

	methods: {
		init() {
			this.$Progress.start()
	      	this.isLoading = true
	      	this.req.get('/tasks/getusers')
	          	.then(res => {
	          		if(res.data.status == 'error') {
	          			this.$Progress.fail()
	              		this.isLoading = false
	              		toastr.error(res.data.text)
	              		return
	          		}
	              	this.users = res.data.users
	              	this.users.splice(0,0,{nev: 'Mind',azon: 99})
	              	this.search.userid = this.user.azon
	              	this.$Progress.finish()
	              	this.isLoading = false
	          	})
	          	.catch(err => {
	              	this.$Progress.fail()
	              	this.isLoading = false
	              	toastr.error(err)
	          	})
		},

		load() {
			this.$Progress.start()
	      	this.isLoading = true
	      	this.req.post('/tasks/gettasks', this.search)
	          	.then(res => {
	          		if(res.data.status === `error`) {
	          			this.$Progress.fail()
	              		this.isLoading = false
	              		toastr.error(res.data.text)
	              		return
	          		}
	              	this.list = res.data.list
	              	this.$Progress.finish()
	              	this.isLoading = false
	          	})
	          	.catch(err => {
	              	this.$Progress.fail()
	              	this.isLoading = false
	              	toastr.error(err)
	          	})
		},

		del(id) {
			this.search[id] = null
		},

		tooltip(text) {
			return `<span class="tooltip-table">${text}</span>`
		},

		checkedHandler(val) {
			this.checked = val
		},

		change(val) {
			this.$Progress.start()
			this.req.post('/tasks/changetask', {
				'cshatarido': this.cshatarido,
				'csfelelos': this.csfelelos,
				'method': val,
				'arr': this.checked
			})
				.then(res=>{
					toastr.success('Változtatás sikeres')
					this.checked = []
					this.cshatarido = this.$moment().format('YYYY-MM-DD')
					this.csfelelos = 0
					this.load()
					this.$Progress.finish()
				})
				.catch(err => {
					console.error(err)
					toastr.error('Változtatás sikertelen')
					this.$Progress.fail()
				})
		}
	},

	computed: {
		...mapGetters(['user'])
	}
}
</script>


// WEBPACK FOOTER //
// src/components/tasks/taskSearch.vue